import styled from 'styled-components';

import { IconWrapper } from '@dreryk/react-components';

export const StyledFavouriteMedicinesSelectorNoResultsIconWrapper = styled(IconWrapper)`
   vertical-align: middle;
   display: inline-flex;
`;
